<template>
    <div class="outer-wrapper" style="text-align: justify;">
    <div class="page-header clear-filter">
    </div>
        <div class="ls section">
            <div class="container">
                <div class="row pd-top-10" style="text-align: justify;">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <h5>About Us</h5>
                        <p>As Indians, everyone wants pure and fresh milk and other dairy products everyday. The keenness of getting fresh milk or dairy products is fundamental to our legacy and we all look back lovingly visits to our native towns and villages. However, it's seen that the quality of milk that gets delivered to our homes is far poorer to what we suppose, reconstituted with milk powder, adultrated and has questionable storage and weak cold chain.</p>
                        <p>Doodhvale.com engages directly with the hi tech dairy farms like our own farms, eliminating all middle men, follows ethical and process oriented production and procurement practices and invests in cold chain logistics and quality testing infrastructure and promise customers to deliver fresh & pure milk and other dairy products to their door step every morning.</p>
                        <p>Doodhvale.com not only delivers the high quality of fresh & pure milk but also our state-of-the-art user friendly mobile app makes our customer life easy like she order once and we deliver daily or alternate days or week days etc, an easy payment options, detailed and transparent billing and single tap order quantity change till 12 AM.</p>
                        <!--ul class="list-type-1">
                            <li class="list__icon-1">
                                <h4 class="list-type-1__title">Progressive technologies</h4>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr</p>
                            </li>
                            <li class="list__icon-2">
                                <h4 class="list-type-1__title">Worldwide Shipping</h4>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr</p>
                            </li>
                            <li class="list__icon-3">
                                <h4 class="list-type-1__title">Smart Cultivation</h4>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr</p>
                            </li>
                        </ul-->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="content-block_t-1">
                <div class="content-block_t-1__content">
                    <h5 class="content-block_t-1__title">Our Mission</h5>
                    <p class="content-block_t-1__text">Mission at Doodhvale.com is to deliver natural, fresh and unadulterated milk to customer doorstep every day. Natural means straight from the farm with no addition of milk powder or preservatives, no hormones or antibiotics. Fresh means that the milk reaches the consumer in 24-36 hours of milking. Unadulterated means scientific quality testing of milk for adulteration at every stage.</p>
                </div>
                <figure class="content-block_t-1__img">
                    <!--img src="images/img_about_post-1.png" alt=""-->
                </figure>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="content-block_t-1">
                <div class="content-block_t-1__content">
                    <h5 class="content-block_t-1__title">Our Team</h5>
                    <p class="content-block_t-1__text"><b>Sudhir Jain </b>- Every family fundamently requires pure and fresh milk and we promise to deliver them same quality of milk like they have their own cattle next to their house.</p>
                    <p class="content-block_t-1__text"><b>Sanjay Kumar Jain</b> - Using Technology it is possible to deliver the fresh and pure milk to large number of families everyday.</p>
                    <p class="content-block_t-1__text"><b>Ishu Jain</b> - Customers are important to us, regular on time delivery of milk at thier doorstep is our priority.</p>
               
                </div>

            </div>
        </div>
        <!--div class="col-lg-4 col-md-4 col-sm-4">
            <div class="content-block_t-1">
                <div class="content-block_t-1__content">
                    <h5 class="content-block_t-1__title">What We Do</h5>
                    <p class="content-block_t-1__text">Doodhvale.com engages directly with the tech dairy farms like doodhvale’s own farm, eliminating all middle men, follows ethical and process oriented procurement practices and invests in cold chain logistics and quality testing infrastructure and promise customers to deliver fresh and pure milk and other dairy products to their door step every morning.</p>
                </div>
               
            </div>
        </div-->
        <div class="ls section_padding_bottom_20">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h5 class="title_t "><img src="img/fssai-logo.jpg" height="80" alt="fssai"> LIC. NO: 10817020000067</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>